import React from 'react';
import uniqueId from 'lodash/uniqueId'
import {themableImagePath} from "../utils/imageUtils";

class TextInputWithLabel extends React.Component {
    constructor(props) {
        super(props);
        this.id = uniqueId("input-");
    }

    render() {
        const inputClassNames = `input-field text-black ${(this.props.errorMessage || this.props.hasError ? " border-red" : "")}`;
        return (
            <div>
                <div className={this.props.classNames || "w-full sm:w-1/2 xl:w-1/3"}>
                    {this.props.label &&
                    <div className="mb-1">
                        <label htmlFor={this.id} className={this.props.labelClassNames || "input-label"}>
                                {this.props.label}
                        </label>
                    </div>
                    }

                    {this.props.subLabel &&
                    <div className="flex items-center text-sm mb-1">
                        {this.props.subLabelIcon &&
                        <img alt="" className="w-4 h-4 mr-2 inline" src={themableImagePath(this.props.subLabelIcon)} />
                        }
                        <span className={this.props.subLabelClasses || ""}>
                            {this.props.subLabel}
                        </span>
                    </div>
                    }

                    <input
                        id={this.id}
                        className={inputClassNames}
                        type={this.props.type || "text"}
                        value={this.props.value}
                        onChange={e => this.props._onChange(e.target.value)}
                        onBlur={this.props.onBlur}
                        placeholder={this.props.placeholder}
                    />
                </div>

                { this.props.errorMessage &&
                <div className="mt-2 errors">
                    {this.props.errorMessage}
                </div>
                }
            </div>
        )
    }
}

export default TextInputWithLabel;